export default [
    {
        name: 'inlineResponseTextStatement',
        title: 'Statement (Text)',
        icon: 'statement-text',
    },
];
